<template>
    <v-app>
        <v-content class="site-guide">
            <v-form>
                <v-container style="max-width: 1140px;" class="site-guide__menu-container">
                    <div class="search">
                        <input type="text" v-model="searchQuery" @keyup.enter="searchArticles">
                        <button @click.prevent="searchArticles">Искать</button>
                    </div>
                    <nav class="site-guide__menu" @click="openDialog = true">
                        <p>Меню</p>
                        <div class="burger">
                            <span class="bar"></span>
                            <span class="bar"></span>
                            <span class="bar"></span>
                        </div>
                    </nav>
                </v-container>
                <div class="side-nav">
                    <div class="search">
                        <input type="text" v-model="searchQuery" @keyup.enter="searchArticles">
                        <button @click.prevent="searchArticles">Искать</button>
                    </div>
                    <v-list dense>
                        <div class="root-main" @click.prevent="openLink('/guide')">
                            <p>Главная</p>
                        </div>
                        <v-list-group
                            v-for="(category, cIndex) in categories"
                            :key="'cat' + cIndex"
                            v-model="category.open"
                            sub-group
                            no-action
                            class="root-group"
                        >
                            <v-list-tile slot="activator">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ category.name }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-group
                                v-for="(sub, sIndex) in category.subcategories"
                                :key="'sub' + sIndex"
                                v-model="sub.open"
                                sub-group
                                no-action
                            >
                                <v-list-tile slot="activator">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ sub.name }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile
                                    v-for="(article, aIndex) in sub.articles"
                                    :key="'art' + aIndex"
                                    @click.prevent="openLink(article.link)"
                                >
                                    <v-list-tile-content
                                        class="tip-icon"
                                        data-tippy-animateFill="false"
                                        data-tippy-placement="bottom"
                                        :data-tippy-content="article.name"
                                    >
                                        <v-list-tile-title >{{ article.name }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list-group>
                        </v-list-group>
                    </v-list>
                </div>

                <v-container v-if="articleData" class="article" style="max-width: 1140px">
                    <v-layout>
                        <v-flex>
                            <v-breadcrumbs v-if="breadcrumbs.length">
                                <v-breadcrumbs-item
                                    v-for="(crumb, index) in breadcrumbs"
                                    :key="index"
                                    :href="crumb.link"
                                >
                                    {{ crumb.name }}
                                </v-breadcrumbs-item>
                            </v-breadcrumbs>
                        </v-flex>
                    </v-layout>
                    <v-layout class="article__main">
                        <v-flex>
                            <h1>{{ parsedArticleData.title }}</h1>
                            <div class="text" v-html="parsedArticleData.text">

                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container style="max-width: 1140px" v-else>
                    <v-layout class="site-guide__title">
                        <v-flex v-if="user && user.user_type">
                            <h1>База знаний - {{ getRoleName(user.user_type)[0] }}</h1>
                            <p>В данном разделе собрана вся ключевая информация относящаяся к работе {{ getRoleName(user.user_type)[1] }}</p>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <v-breadcrumbs v-if="breadcrumbs.length">
                                <v-breadcrumbs-item
                                    v-for="(crumb, index) in breadcrumbs"
                                    :key="index"
                                    :href="crumb.link"
                                >
                                    {{ crumb.name }}
                                </v-breadcrumbs-item>
                            </v-breadcrumbs>
                        </v-flex>
                    </v-layout>
                    <v-layout class="site-guide__search-results" v-if="isSearchClicked">
                        <v-flex>
                            <p v-if="searchResults.length">
                                Результаты по запросу «{{ searchQuery }}»: найдено {{ searchResults.length }} совпадений.
                            </p>
                            <p v-else>
                                По запросу «{{ searchQuery }}» ничего не найдено.
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap row class="guide-items-wrapper">
                        <v-flex
                            class="guide-item sm6"
                            v-for="key in 10"
                            :key="key"
                            v-show="loadingFetchArticles"
                        >
                            <a class="guide-link skeleton" />
                        </v-flex>
                        <v-flex
                            class="guide-item"
                            :class="{ 'sm6': !(isLastSingle(key)), 'sm12': isLastSingle(key) }"
                            v-for="(item, key) in arrayToShow"
                            :key="item.slug || item.name"
                            v-show="!loadingFetchArticles"
                        >
                            <a class="guide-link"
                               :href="item.link"
                               @click.stop
                                   ="item.type === 'category' ? openLink(item.link) : item.type === 'subcategory' ? openLink(item.link) : openLink(item.link)"
                               v-html="item.name"/>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
        <template>
            <v-layout>
                <v-dialog v-model="openDialog" transition="dialog-right-transition" class="feedback-dialog v-dialog" content-class="site-guide__modal" style="display: none">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-list dense>
                                        <div class="root-main" @click.prevent="openLink('/guide')">
                                            <p>Главная</p>
                                        </div>
                                        <v-list-group
                                            v-for="(category, cIndex) in categories"
                                            :key="'cat' + cIndex"
                                            v-model="category.open"
                                            sub-group
                                            no-action
                                            class="root-group"
                                        >
                                            <v-list-tile slot="activator">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ category.name }}</v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>

                                            <v-list-group
                                                v-for="(sub, sIndex) in category.subcategories"
                                                :key="'sub' + sIndex"
                                                v-model="sub.open"
                                                sub-group
                                                no-action
                                                prepend-icon=""
                                            >
                                                <v-list-tile slot="activator">
                                                    <v-icon class="mr-2" v-if="!sub.open">mdi-chevron-right</v-icon>
                                                    <v-icon class="mr-2" v-else>mdi-chevron-down</v-icon>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ sub.name }}</v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                <v-list-tile
                                                    v-for="(article, aIndex) in sub.articles"
                                                    :key="'art' + aIndex"
                                                    @click.prevent="openLink(article.link)"
                                                >
                                                    <v-list-tile-content
                                                        class="tip-icon"
                                                        data-tippy-animateFill="false"
                                                        data-tippy-placement="bottom"
                                                        :data-tippy-content="article.name"
                                                    >
                                                        <v-list-tile-title>{{ article.name }}</v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-list-group>
                                        </v-list-group>
                                    </v-list>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <img :src="pathToCloseModalSvg" class="close-modal" alt="close-modal" @click="openDialog = !openDialog">
                    </v-card>
                </v-dialog>
            </v-layout>
        </template>
    </v-app>
</template>

<script>
export default {
    props: ['category', 'subcategory', 'article', 'articleData', 'user'],
    data: () => ({
        selectedCategory: null,
        selectedSubcategory: null,
        selectedArticle: null,
        categories: [],
        openDialog: false,
        pathToCloseModalSvg: '/svg/arrow-up-right.svg',
        parsedArticleData: null,
        searchQuery: '',
        searchResults: [],
        isSearchClicked: false,
        loadingFetchArticles: true,
    }),

    mounted() {
        const observer = new MutationObserver(() => {
            document.querySelectorAll('.tip-icon').forEach(el => {
                if (!el._tippy) {
                    window.tippy.default(el);
                }
            });
        });

        observer.observe(this.$el, { childList: true, subtree: true });

        this.toggleScrollLock(this.openDialog);
    },

    beforeUnmount() {
        observer.disconnect();
        this.toggleScrollLock(false);
    },

    created() {
        this.fetchArticles();

        if (this.category) {
            this.selectedCategory = this.category;
        }
        if (this.subcategory) {
            this.selectedSubcategory = this.subcategory;
        }
        if (this.article) {
            this.selectedArticle = this.article;
            /*this.fetchCurrentArticle(this.article);*/
        }
        if (this.articleData) {
            this.parsedArticleData = JSON.parse(window.atob(this.articleData)).original.data;
        }

    },
    methods: {
        fetchArticles() {
            const url = '/guide/api/articles';

            axios.get(url)
                .then(response => {
                    if (response && response.data) {
                        this.categories = response.data.categories;

                        if (this.selectedCategory) {
                            this.categories.forEach(category => {
                                category.open = (category.slug === this.selectedCategory);
                            });
                        }

                        if (this.selectedSubcategory) {
                            this.categories.forEach(category => {
                                category.open = (category.slug === this.selectedCategory);
                                category.subcategories.forEach(sub => {
                                    sub.open = (sub.slug === this.selectedSubcategory);
                                });
                            });
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.loadingFetchArticles = false;
                })

        },

        fetchCurrentArticle(articleSlug) {
            const url = '/guide/api/articles/';

            try {
                const response = axios.get(url + articleSlug);
            } catch (error) {
                console.error('fetchCurrentArticle: ', error)
            }
        },

        isLastSingle(index) {
            return this.arrayToShow.length % 2 !== 0 && index === this.arrayToShow.length - 1;
        },

        openLink(originalUrl) {
            try {
                window.location.href = originalUrl;
            } catch (error) {
                console.error('Некорректный URL:', originalUrl);
            }
        },

        searchArticles() {
            const query = this.searchQuery.trim().toLowerCase();
            if (!query) {
                this.searchResults = [];
                return;
            }

            this.isSearchClicked = true;
            const results = [];

            this.categories.forEach(category => {
                category.subcategories.forEach(sub => {
                    sub.articles.forEach(article => {
                        if (article.name.toLowerCase().includes(query)) {
                            results.push({
                                ...article,
                                type: 'article',
                                parentCategorySlug: category.slug,
                                parentSubSlug: sub.slug
                            });
                        }
                    });
                });
            });

            this.searchResults = results;
        },

        getRoleName(userType) {
            const roles = {
                admin: ['Админ', 'админа'],
                curator: ['Куратор', 'куратора'],
                agent: ['Агент', 'агента'],
                operator: ['Сотрудник', 'сотрудника'],
                client: ['Клиент', 'клиента']
            };
            return roles[userType] || ['—', 'пользователя'];
        },

        toggleScrollLock(shouldLock) {

            const htmlEl = document.documentElement;
            if (!htmlEl) return;

            htmlEl.classList.toggle('no-scroll', shouldLock);
        }
    },
    computed: {
        subcategories() {
            if (!this.categories.length) return [];

            const category = this.categories.find(item => item.slug === this.selectedCategory);

            return category ? category.subcategories : [];
        },
        arrayToShow() {
            if (!this.categories) return;
            if (this.searchResults.length > 0) return this.searchResults;
            if (this.showArticleDetail) return [];

            if (!this.selectedCategory) return this.rootCategories;
            if (!this.selectedSubcategory) return this.subcategoriesOfSelected;

            return this.articlesOfSelected;
        },

        // 1. Категории верхнего уровня
        rootCategories() {
            if (!this.categories) return [];

            return this.categories.map(category => ({
                ...category,
                type: 'category'
            }));
        },

        // 2. Подкатегории выбранной категории
        subcategoriesOfSelected() {
            if (!this.categories) return [];

            const category = this.categories.find(c => c.slug === this.selectedCategory);
            if (!category) return [];

            return category.subcategories.map(sub => ({
                ...sub,
                type: 'subcategory',
                parentSlug: category.slug
            }));
        },

        // 3. Статьи выбранной подкатегории
        articlesOfSelected() {
            if (!this.categories) return [];

            const category = this.categories.find(c => c.slug === this.selectedCategory);

            if (!category) return [];

            if (this.selectedSubcategory) {
                const subcategory = category.subcategories.find(s => s.slug === this.selectedSubcategory);
                if (!subcategory) return [];

                return subcategory.articles.map(article => ({
                    ...article,
                    type: 'article',
                    parentCategorySlug: category.slug,
                    parentSubSlug: subcategory.slug,
                }));
            }
        },

        // 4. Проверка на отображение деталей статьи
        showArticleDetail() {
            return this.selectedCategory &&
                this.selectedSubcategory &&
                this.selectedArticle;
        },

        breadcrumbs() {
            if (!this.selectedCategory) {
                return [];
            }

            const result = [];

            result.push({
                name: 'Главная',
                link: '/guide'
            });

            const category = this.categories.find(cat => cat.slug === this.selectedCategory);
            if (category) {
                result.push({
                    name: category.name,
                    link: category.link
                });

                if (this.selectedSubcategory) {
                    const subcategory = category.subcategories.find(sub => sub.slug === this.selectedSubcategory);
                    if (subcategory) {
                        result.push({
                            name: subcategory.name,
                            link: subcategory.link
                        });
                    }
                }
            }

            return result;
        },
    },
    watch: {
        openDialog(val) {
            this.toggleScrollLock(val);
        },
    },
}
</script>

<style lang="scss" scoped>
.site-guide {
    position: relative;
    max-width: 1140px;
    width: 100%;
    margin: 0 auto;
    padding-top: 80px !important;
    @media(max-width: 600px) {
        padding-top: unset !important;
    }

    .v-breadcrumbs {
        padding: 12px 0;
    }

    .root-group {
        .v-list__group__header__prepend-icon {
            padding: 0 !important;
            margin-right: 8px;
        }
    }

    .tip-icon {
        width: unset;
    }

    &__menu-container {
        display: none;
        @media(max-width: 1800px) {
            display: block;
        }
    }

    &__menu {
        display: none;
        justify-content: space-between;
        align-items: center;
        padding: 12px 20px;
        background-color: #F1F3F2;
        border-radius: 6px;
        cursor: pointer;
        @media(max-width: 600px) {
            padding: 8px 10px;
            border-radius: 3px;
        }

        @media(max-width: 1800px) {
            display: flex;
        }

        p {
            margin-bottom: 0;
            font-family: 'SFPro', 'Arial', 'sans-serif';
            font-size: 24px;
            @media(max-width: 600px) {
                font-size: 16px;
            }
        }

        .burger {
            .bar {
                display: block;
                width: 22px;
                height: 3px;
                margin: 4px auto;
                -webkit-transition: all 0.3s ease-in-out;
                background-color: #000000;
                border-radius: 20px;
                @media(max-width: 600px) {
                    height: 2px;
                }
            }
        }
    }

    &__title {
        h1 {
            font-family: 'SFProBold', 'Arial', 'sans-serif';
            font-size: 30px;
            line-height: 28px;
            color: #1B1B1B;
            margin-bottom: 24px;
            @media(max-width: 600px) {
                font-size: 22px;
                line-height: 28px;
                margin-bottom: 15px;
            }
        }

        p {
            font-family: 'SFPro', 'Arial', 'sans-serif';
            font-size: 16px;
            color: #1B1B1B;
            margin-bottom: 0;
            @media(max-width: 600px) {
                font-size: 14px;
            }
        }
    }

    &__search-results {
        p {
            font-family: 'SFPro', 'Arial', 'sans-serif';
            font-size: 16px;
            color: #1B1B1B;
            margin-bottom: 0;
            @media(max-width: 600px) {
                font-size: 14px;
            }
        }
    }

    .guide-items-wrapper {
        min-height: 600px;
    }

    .guide-item {
        height: 320px;
        @media(max-width: 600px) {
            width: 100%;
            height: 143px;
        }

        .guide-link {
            display: block;
            background-color: #F1F3F2;
            border-radius: 15px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            color: #1B1B1B;
            text-decoration: none;
            font-family: 'SFUPro', 'Arial', 'sans-serif';
            font-size: 26px;
            padding: 40px;
            @media(max-width: 600px) {
                padding: 20px;
                font-size: 16px;
            }

            &:hover {
                background-color: #00B153;
                color: #FFFFFF;
                transition: all 0.3s ease;
            }
        }

        .skeleton {
            position: relative;
            overflow: hidden;
            background-color: #e5e7eb;
        }

        .skeleton::after {
            content: '';
            position: absolute;
            inset: 0;

            transform: translateX(-100%);

            background: linear-gradient(
                    90deg,
                    transparent,
                    rgba(255, 255, 255, 0.5),
                    transparent
            );

            animation: skeleton-loading 1.2s infinite;

            pointer-events: none;
        }

        @keyframes skeleton-loading {
            to {
                transform: translateX(100%);
            }
        }
    }

    .side-nav {
        position: absolute;
        top: 0;
        left: calc(-310px - 30px);
        width: 310px;
        height: 100vh;
        overflow-y: auto;
        box-sizing: border-box;

        @media(max-width: 1800px) {
            display: none;
        }
    }

    .search {
        display: flex;
        margin-bottom: 58px;
        @media(max-width: 1800px) {
            margin-bottom: 38px;
        }

        input {
            all: unset;
            border-top: 2px solid #D8D8D8;
            border-left: 2px solid #D8D8D8;
            border-bottom: 2px solid #D8D8D8;
            /*padding: 5px 10px;*/
            @media(max-width: 1800px) {
                width: 100%;
            }

            &:focus {
                border-top: 2px solid #BBBBBBFF;
                border-left: 2px solid #BBBBBBFF;
                border-bottom: 2px solid #BBBBBBFF;
            }
        }

        button {
            padding: 12px 28px;
            background-color: #F1F3F2;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            font-size: 16px;
        }
    }
}

.root-main {
    display: flex;
    height: 40px;
    align-items: center;
    padding: 0 8px;
    cursor: pointer;

    &:hover {
        background: rgba(0,0,0,0.07);
    }

    p {
        font-family: 'SFPro', 'Arial', 'sans-serif';
        font-size: 18px;
        color: #1B1B1B;
        margin: 0;
        @media(max-width: 600px) {
            font-size: 14px;
        }
    }
}
</style>

<style lang="scss">
.site-guide {
    a {
        &:hover {
            color: #01ad51;
        }
    }
}
.article {
    &__main {
        h1 {
            font-size: 30px;
            line-height: 28px;
            color: #1B1B1B;
            font-family: 'SFUIPro', 'Arial', 'sans-serif';
            margin-bottom: 23px;
            @media (max-width: 600px) {
                font-size: 20px;
                line-height: 24px;
                margin-bottom: 20px;
            }
        }

        .text {
            p {
                font-size: 18px;
                color: #1B1B1B;
                text-align: justify;
                font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
                margin-bottom: 18px;
                @media (max-width: 600px) {
                    font-size: 14px;
                    margin-bottom: 14px;
                }
            }

            img {
                max-width: 100%;
                height: auto;
                display: block;
                margin-left: auto;
                margin-right: auto;
            }

            ul {
                margin-bottom: 18px;
                @media (max-width: 600px) {
                    margin-bottom: 14px;
                }
            }

            li {
                font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
                font-size: 18px;
                color: #1B1B1B;
                text-align: justify;
                @media (max-width: 600px) {
                    font-size: 14px;
                }
            }
        }
    }
}

.root-group > .v-list__group__header .v-list__group__header__prepend-icon {
    padding: 0 !important;
    margin-right: 8px;
    min-width: unset;
}

.site-guide__modal {
    margin: 0;
    z-index: 1002 !important;
    width: 320px;

    .close-modal {
        position: absolute;
        top: 18px;
        right: 18px;
        cursor: pointer;
    }

    .v-list__group {
        &:before {
            content: none;
        }

        &:after {
            content: none;
        }
    }

    .root-main {
        p {
            font-size: 14px;
        }
    }
}

.v-dialog__content {
    width: auto;
    right: -100%;
    left: unset;
    top: 0;
    bottom: 0;
    height: unset;
}
.v-dialog__content--active {
    top: 0;
    bottom: 0;
    right: 0;
}

.no-scroll {
    overflow: hidden;
}

.v-card {
    height: 100%;
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    display: flex;
    align-items: center;
    position: relative;

    &__text {
        margin-top: 60px;
        margin-bottom: 60px;
    }
}

.site-guide {
    .v-list__tile__title {
        font-size: 18px;
        @media(max-width: 600px) {
            font-size: 14px;
        }
    }

    .v-list__group {
        &:before {
            content: none;
        }

        &:after {
            content: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/site-guide/SiteGuide.vue